import { FileGroup } from "../../beneficiari.interface";

// Category icons
export const DosarCategoryIcons: Record<string, string> = {
    'dosar-medical': 'fa-solid fa-kit-medical',
    'dosar-educational': 'fa-solid fa-graduation-cap',
    'dosar-juridic': 'fa-solid fa-scale-balanced',
    'dosar-psihologic': 'fa-solid fa-brain',
    'dosar-familial': 'fa-solid fa-people-roof',
    'dosar-beneficiar': 'fa-solid fa-user-shield',
    'altele': 'fa-solid fa-folder-open',
};

export enum OrderMode {
    ASCENDING = 1,
    DESCENDING = -1,
}

export enum ViewMode {
    BY_CATEGORY = 'by_category',
    BY_DATE = 'chronological',
    BY_TAG = 'by_tag',
    BY_UPLOADER = 'by_uploader',
}

export interface InvolvedPerson {
    id?: number;
    full_name: string;
    cnp?: string;
    relationship_type_id: number,
    relationship_type_name: string,
    relationship_specific_id: number,
    relationship_specific_name: string,
    // role: string;           // e.g. "Titular", "Soț/Soție", "Copil"
    // relation?: string;      // e.g. "Părinte", "Frate"
}

// Grouped structures for display
export interface ViewCard {
    label: string;
    icon?: string;
    color?: string;
    fileGroups: FileGroup[];
    // subgroups?: ViewCard[];    // e.g. medical sub-sections
}